import * as actionType from '../action';
import {Business} from '../../Items/Business'

interface BusinessState {
    businesses: Business[];
}
  
  const initialState: BusinessState = {
    businesses: [],
};

const BusinessReducer = (state = initialState, action:any) : BusinessState => {
    switch (action.type) {
        case actionType.GET_BUSINESSES: {
            return { ...state, businesses: action.payload };
        }
        case actionType.ADD_BUSINESS:{
            return { ...state, businesses: [...state.businesses, action.payload] };
        }
        case actionType.EDIT_BUSINESS:{
            return {
                ...state,
                businesses: state.businesses.map((u) =>
                  u.id === action.payload.id ? action.payload : u
                ),
            };
        }
        case actionType.DELETE_BUSINESS:{
            return{
                ...state,
                businesses: state.businesses.filter((b) => b.id !== action.payload)
            }
        }
        default:
            return { ...state };
    }
}

export default BusinessReducer;